<template>
  <div class="home">
    <aheader :phone="phone" :logoObj="logoObj" :loginStatus="loginStatus" :skinColor="skinColor" :seniorFlog="seniorFlog" />
    <amenu :curClass="curClass" :mainConfig="mainConfig" :curArea="curArea" @openLink="openLink" :skinColor="skinColor" />
    <template v-if="mainConfig.HaveCourseFlag === 1">
      <Banner :domain="curDomain" :imgUrl="mainConfig.BannerImgs"></Banner>
      <avideo :auditionCourseList="auditionCourseList" v-if="auditionCourseList.length > 0" :phone="phone" :mainConfig="mainConfig" :loginStatus="loginStatus" />
      <recommend :teacherList="teacherList" :mainConfig="mainConfig" :unionBkzn="unionBkzn" :countDown="countDown" :skinColor="skinColor" @openLink="openLink" v-if="Object.keys(mainConfig).length > 0" />
      <!-- <meal :curMeal="curMeal" :fineAndDiy="fineAndDiy" :contrastList="contrastList" @changeClassObj="changeClassObj" @changeGift="changeGift" /> -->
      <div class="meal">
        <h2 class="contrast-title">辅导方案</h2>
        <contrast :ShowRelearn="ShowRelearn" :fineAndDiy="fineAndDiy" :contrastList="contrastList" v-if="contrastList.length > 1" @changeClassObj="changeClassObj" @changeGift="changeGift" />
        <atitle :title="`${mainConfig.ClassCName}学习班型`" class="meal-flag" v-if="(curMeal && Object.keys(curMeal).length > 0 && curMeal.KsContainBanJiList.length > 0) || contrastList.length > 1">
          <div class="atitle-labels" v-if="mealList.length > 1">
            <label v-for="item in mealList" :key="item.KsName" :class="curMeal.KsName === item.KsName ? 'select' : ''" @click="curMeal = item">
              {{ item.KsName }}
            </label>
          </div>
        </atitle>
        <carousel :curMeal="curMeal" :ShowRelearn="ShowRelearn" @changeClassObj="changeClassObj" v-if="curMeal && Object.keys(curMeal).length > 0 && curMeal.KsContainBanJiList.length > 0" />
      </div>
      <atitle :title="`${mainConfig.ClassCName}基础班级`" class="bar-xxfa-flag" v-if="basicClassList.length > 0" />
      <aclass :basicClassList="basicClassList" v-if="basicClassList.length > 0" @changeSVideo="changeSVideo" :skinColor="skinColor" />
      <atitle :title="'官方教材'" v-if="bookList.length > 0" />
      <book :bookList="bookList" v-if="bookList.length > 0" />
      <atitle :title="`${mainConfig.ClassCName}题库`" />
      <topic :topicList="topicList" @openLink="openLink" :skinColor="skinColor" />
      <atitle :title="'常见问题'" />
      <problem :problemObj="problemObj" />
    </template>
    <template v-else>
      <div class="not-config">
        <img src="https://img2.233.com/wx/union/pure/pc/default_no.png" />
        <p>暂无课程</p>
      </div>
    </template>
    <afooter :footerList="footerList" />
    <adialog :curType="curType" :curClassObj="curClassObj" :title="dialogTitle" :curSVideoObj="curSVideoObj" :curGiftList="curGiftList" :mainConfig="mainConfig" :loginStatus="loginStatus" ref="dialog" />
    <div class="page-loading" v-if="pageLoading">
      <img src="https://img2.233.com/wx/union/pure/pc/loading.gif" />
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner/index.vue";
import qrcode from "qrcodejs2";
import { GetCategoryChildClassAndAreaList, GetUnionBkzn, GetCategoryAuditionCourseList, GetExaminationCountDown, GetCategoryTeacherList, GetCategoryTaoCanCourseList, GetCategoryJiChuCourseList, GetCategoryFineBanJiContrastList, GetCategoryNormBanJiContrastList, GetCategoryBookList, GetCategoryTikuPaperList, GetUnionLogoByHost, GetPhoneByHost, GetFooterByHost, GetSeniorFlag, GetLoginStatus, GetUnionPermission } from "../../lib/request";
import aheader from "./cell/header";
import amenu from "./cell/menu";
import avideo from "./cell/video/index";
import recommend from "./cell/recommend/index";
import atitle from "./cell/title";
// import meal from "./cell/meal/index"
import carousel from "./cell/meal/cell/carousel";
import contrast from "./cell/meal/cell/contrast";
import aclass from "./cell/aclass";
import book from "./cell/book";
import topic from "./cell/topic";
import problem from "./cell/problem";
import afooter from "./cell/footer";
import adialog from "./cell/dialog/index";
import { getTikuPath } from "@/utils";
export default {
  name: "Home",
  components: {
    aheader,
    amenu,
    avideo,
    recommend,
    atitle,
    // meal,
    carousel,
    contrast,
    aclass,
    book,
    topic,
    problem,
    afooter,
    adialog,
    Banner
  },
  data() {
    return {
      curClass: "jzs1",
      mainConfig: {},
      unionBkzn: {},
      curArea: "",
      auditionCourseList: [],
      countDown: {},
      teacherList: [],
      basicClassList: [],
      curMeal: {},
      curClassObj: {},
      mealList: [],
      contrastList: [],
      fineAndDiy: false,
      bookList: [],
      topicList: [],
      logoObj: {},
      phone: "",
      footerList: [],
      loginStatus: {},
      problemObj: {},
      dialogTitle: "",
      curType: "",
      curSVideoObj: {},
      curGiftList: [],
      skinColor: "red",
      pageLoading: true,
      seniorFlog: false,
      ShowRelearn: 0
    };
  },
  watch: {
    "$route.query"() {
      window.location.reload();
    }
  },
  async created() {
    if (this.$route.query.class) {
      this.curClass = this.$route.query.class;
    }
    console.log(this.curClass);
    try {
      await this.handlerCheckUnionIsOnline();
    } catch (error) {
      console.log(error);
    }

    this.GetSeniorFlag();
    if (this.$route.query.area) {
      this.curArea = this.$route.query.area;
    }
    this.GetUnionLogoByHost();
    this.GetPhoneByHost();
    this.GetFooterByHost();
    this.GetLoginStatus();
    this.GetCategoryChildClassAndAreaList();
    this.GetUnionBkzn();
  },
  computed: {
    curDomain() {
      let temp = this.curClass;
      let params = window.UnionDomainParam || {
        ck: "chengkao",
        fakao: "sf",
        jjxs: "jjcy",
        gongzhao: "jszp"
      };
      let result = params[temp] || temp;
      return result;
    }
  },
  methods: {
    //   // 检查新的页面是否上线
    async handlerCheckUnionIsOnline() {
      const { data } = await this.$api.handlerCheckUnionIsOnline({
        domain: this.curClass
      });
      if (process.env.NODE_ENV === "development") {
        console.log("localhost");
      } else {
        // 跳转新的联盟页面
        if (data?.pcNewSite == 1) {
          location.href = location.origin + "/" + this.curDomain;
          return Promise.reject("jump new location");
        }
      }
    },
    init() {
      this.getActivityAdv();
      this.GetCategoryAuditionCourseList();
      this.GetExaminationCountDown();
      this.GetCategoryTeacherList();
      this.GetCategoryTaoCanCourseList();
      this.GetCategoryJiChuCourseList();
      this.GetCategoryBookList();
      this.GetCategoryTikuPaperList();
      this.GetUnionPermission();
    },
    getActivityAdv() {
      if (this.mainConfig.SaoMaUrl) {
        if (document.querySelector(".right-bar-qrcode")) {
          new qrcode(document.querySelector(".right-bar-qrcode"), {
            text: this.mainConfig.SaoMaUrl,
            width: 132,
            height: 132,
            colorDark: "#000",
            colorLight: "#fff"
          });
        }
      } else {
        if (document.querySelector(".right-bar .bar-wechat")) {
          document.querySelector(".right-bar .bar-wechat").style.display = "none";
        }
      }
    },

    GetUnionLogoByHost() {
      GetUnionLogoByHost({}, (res) => {
        this.logoObj = res.Result;
      });
    },
    GetPhoneByHost() {
      GetPhoneByHost({}, (res) => {
        this.phone = res.Result;
      });
    },
    GetFooterByHost() {
      GetFooterByHost({}, (res) => {
        this.footerList = res.Result;
      });
    },
    /* eslint-disable */
    GetSeniorFlag() {
      GetSeniorFlag({}, (res) => {
        this.seniorFlog = res.Result;
        if (res.Result) {
          location.href.indexOf("/norm") > -1 ? (location.href = location.href.replace("/norm", "/fine")) : this.toH5(this.curClass);
        } else {
          location.href.indexOf("/fine") > -1 ? (location.href = location.href.replace("/fine", "/norm")) : this.toH5(this.curClass);
        }
        res.Result ? this.GetCategoryFineBanJiContrastList() : this.GetCategoryNormBanJiContrastList();
      });
    },
    toH5(curClass) {
      (function(_nu) {
        if ((/AppleWebKit.*Mobile/i.test(_nu) || /Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(_nu) || /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(_nu)) && !/iPad/i.test(_nu) && location.hash != "#m") {
          window.location.href = window.location.origin + window.location.pathname.replace("/norm/category/currency/", "/m/norm/channel/").replace("/fine/category/currency/", "/m/fine/channel/") + curClass;
        }
      })(window.navigator.userAgent);
    },
    GetLoginStatus() {
      GetLoginStatus({}, (res) => {
        this.loginStatus = res.Result;
      });
    },
    GetCategoryChildClassAndAreaList() {
      GetCategoryChildClassAndAreaList({ classEName: this.curClass }, (res) => {
        this.pageLoading = false;
        const { Result } = res;
        this.mainConfig = Result;
        // if (Result.SkinColor === "") {
        // location.href = Result.OldCategoryUrl;
        // }
        if (Result.SkinColor !== "red") {
          window.document.documentElement.setAttribute("data-theme", Result.SkinColor);
          this.skinColor = Result.SkinColor;
        }
        if (Result.CategoryCourseAreaList.length > 0 && !Result.CategoryCourseAreaList.find((item) => this.curArea === item.AreaEName)) {
          this.curArea = Result.CategoryCourseAreaList[0].AreaEName;
        }
        if (Result.HaveCourseFlag === 1) {
          this.init();
        } else {
          if (document.querySelector(".right-bar")) {
            document.querySelector(".right-bar").style.display = "none";
          }
        }
      });
    },
    GetUnionBkzn() {
      GetUnionBkzn({ domain: this.curClass, type: 0 }, (res) => {
        this.unionBkzn = res.Result;
      });
    },
    GetCategoryAuditionCourseList() {
      GetCategoryAuditionCourseList({ classEName: this.curClass, diquName: this.curArea }, async (res) => {
        // 通过netId查询视频信息
        const auditionCourseList = res.Result || [];
        const netDetailIds = auditionCourseList
          .map((item) => {
            return item.PlayDCourseId;
          })
          .join(",");
        const { data: videoInfoResList = [] } = await this.$api.getPlayChannelByDcourseId({ netDetailIds });
        // 播放地址修改
        auditionCourseList.forEach((item, index) => {
          const videoInfo = videoInfoResList.find((videoInfo) => videoInfo.netDetailId === item.PlayDCourseId);

          const params = {
            unioncode: '',
            polyVid: '',
            aliyunVid: ''
          };
          params.unioncode = window.location.host;
          params.polyVid = videoInfo.lmPolyVid || videoInfo.polyVid;
          params.aliyunVid = videoInfo.lmAliyunVid || videoInfo.aliyunVid;
          item.PlayUrl = `https://wx.233.com/videoPlayer/index.html?polyVid=${params.polyVid}&aliyunVid=${params.aliyunVid}&unioncode=${params.unioncode}`;
        });
        console.log(auditionCourseList);
        this.auditionCourseList = auditionCourseList;
      });
    },
    GetExaminationCountDown() {
      GetExaminationCountDown({ classEName: this.curClass, diquName: this.curArea }, (res) => {
        this.countDown = res.Result;
      });
    },
    GetCategoryTeacherList() {
      GetCategoryTeacherList({ classEName: this.curClass }, (res) => {
        this.teacherList = res.Result;
      });
    },
    GetCategoryTaoCanCourseList() {
      GetCategoryTaoCanCourseList({ classEName: this.curClass, diquName: this.curArea }, (res) => {
        this.mealList = res.Result;
        this.curMeal = res.Result[0];
      });
    },
    GetCategoryJiChuCourseList() {
      GetCategoryJiChuCourseList({ classEName: this.curClass, diquName: this.curArea }, async (res) => {
        // 获取播放id
        const netDetailObjs = {}
        res.forEach(item => {
          (item.BzContainKsList || []).forEach(item => {
            (item.KsMultiVersionList || []).forEach(item => {
              if(item.PlayMyClassDetailList && item.PlayMyClassDetailList.length) {
                netDetailObjs[item.PlayMyClassId] = item.PlayMyClassDetailList[0].DCourseId
              }
            })
          })
        });
        const netDetailIds = Object.values(netDetailObjs).join(',')
        const { data: videoInfoResList = [] } = await this.$api.getPlayChannelByDcourseId({ netDetailIds });
        // 播放地址修改成阿里云的
        res.forEach(item => {
          (item.BzContainKsList || []).forEach(item => {
            (item.KsMultiVersionList || []).forEach(item => {
              const PlayDCourseId = netDetailObjs[item.PlayMyClassId]
              if(PlayDCourseId) {
                const videoInfo = videoInfoResList.find((videoInfo) => videoInfo.netDetailId === PlayDCourseId);
                const params = {
                  unioncode: '',
                  polyVid: '',
                  aliyunVid: ''
                };
                params.unioncode = window.location.host;
                params.polyVid = videoInfo.lmPolyVid || videoInfo.polyVid;
                params.aliyunVid = videoInfo.lmAliyunVid || videoInfo.aliyunVid;
                item.PlayUrl = `https://wx.233.com/videoPlayer/index.html?polyVid=${params.polyVid}&aliyunVid=${params.aliyunVid}&unioncode=${params.unioncode}`;
              }
            })
          })
        });
        console.log(res);
        this.basicClassList = res;
        if (this.basicClassList.length === 0) {
          if (document.querySelector(".bar-kcst")) {
            document.querySelector(".bar-kcst").remove();
          }
        }
      });
    },
    //高级平台
    GetCategoryFineBanJiContrastList() {
      GetCategoryFineBanJiContrastList({ classEName: this.curClass, diquName: this.curArea }, (res) => {
        const { Result } = res;
        this.ShowRelearn = Result.ShowRelearn;
        if (Result.CategoryDefaultBanJiContrast && Result.CategoryDefaultBanJiContrast.List && Result.CategoryDefaultBanJiContrast.List.length > 0) {
          this.contrastList = Result.CategoryDefaultBanJiContrast.List;
        } else {
          this.fineAndDiy = true;
          const _arr = [];
          Result.CategoryDiyBanJiContrast.forEach((element) => {
            let Explain = "",
              KCBZ = [],
              BHBJ = [],
              TSBJ = [],
              KCTS = [],
              Details = [],
              diyPrice = "";
            element.typeList.forEach((item) => {
              switch (item.TypeId) {
                case 1:
                  item.Content.forEach((ii) => {
                    Details.push({
                      Details: ii.StyContentList,
                      Price: ii.Price,
                      RowName: ii.Contents,
                      SpecialPrice: null
                    });
                  });
                  diyPrice = element.GoodPrice;
                  // item.Content.forEach(ii => {
                  //   _StyContentList.push(ii.StyContentList)
                  // })
                  // Details.push({
                  //   Details: _StyContentList,
                  //   Price: element.GoodPrice,
                  //   RowName: "",
                  //   SpecialPrice: null
                  // })
                  break;
                case 2:
                  item.Content.forEach((ii) => {
                    Explain = Explain + "↵" + ii.Contents;
                  });
                  Explain = Explain.slice(1, Explain.length);
                  break;
                case 3:
                  item.Content.forEach((ii) => {
                    const { Contents } = ii;
                    BHBJ.push({ Contents });
                  });
                  break;
                case 4:
                  item.Content.forEach((ii) => {
                    const { Contents, StyleId, StyleName } = ii;
                    KCBZ.push({ Contents, StyleId, StyleName });
                  });
                  break;
                case 5:
                  item.Content.forEach((ii) => {
                    const { Contents, StyleId, StyleName } = ii;
                    TSBJ.push({ Contents, StyleId, StyleName });
                  });
                  break;
                case 6:
                  item.Content.forEach((ii) => {
                    const { Contents, StyleId, StyleName } = ii;
                    KCTS.push({ Contents, StyleId, StyleName });
                  });
                  break;
                default:
                  break;
              }
            });
            _arr.push({
              BzCname: element.CourseName,
              Explain,
              BHBJ,
              KCBZ,
              TSBJ,
              KCTS,
              Details,
              diyPrice
            });
          });
          this.contrastList = _arr;
        }
      });
    },
    //普通平台
    GetCategoryNormBanJiContrastList() {
      GetCategoryNormBanJiContrastList({ classEName: this.curClass, diquName: this.curArea }, (res) => {
        const { Result } = res;
        this.ShowRelearn = Result.ShowRelearn;
        this.contrastList = Result.List;
      });
    },
    GetCategoryBookList() {
      GetCategoryBookList({ classEName: this.curClass }, (res) => {
        this.bookList = res;
      });
    },
    GetCategoryTikuPaperList() {
      GetCategoryTikuPaperList({ classEName: this.curClass }, (res) => {
        this.topicList = res.Result;
      });
    },
    GetUnionPermission() {
      GetUnionPermission({}, (res) => {
        this.problemObj = res.Result;
      });
    },
    openLink(type) {
      const domain = this.curClass;
      switch (type) {
        case 1:
          window.open(window.location.origin + "/header/coursetaste/coursetaste.html");
          break;
        case 2:
          if (this.loginStatus.status) {
            window.open(window.location.origin + "/v5/course/unionmy");
          } else {
            window.location.href = window.location.origin + "/uc/login?redirecturl=" + window.location.href;
          }
          break;
        case 3:
          var url = getTikuPath(1, { domain });
          window.open(url);
          break;
        case 4:
          var url = getTikuPath(6, { domain });
          window.open(url);
          break;
        case 5:
          var url = getTikuPath(3, { domain });
          window.open(url);
          break;
        case 6:
          var url = getTikuPath(4, { domain });
          window.open(url);
          break;
        case 7:
          var url = getTikuPath(2, { domain });
          window.open(url);
          break;
        case 8:
          var url = getTikuPath(5, { domain });
          window.open(url);
          break;
        default:
          break;
      }
    },
    changeClassObj(list) {
      this.dialogTitle = list.BzCName;
      this.curClassObj = list;
      this.curType = "selectClass";
      this.$refs.dialog.show = true;
    },
    changeSVideo(url, title) {
      this.dialogTitle = title;
      this.curSVideoObj = {
        url,
        class: this.curClass
      };
      this.curType = "sVideo";
      this.$refs.dialog.show = true;
    },
    changeGift(list) {
      this.dialogTitle = "赠品详情";
      this.curGiftList = list;
      this.curType = "gift";
      this.$refs.dialog.show = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/index.scss";
.home {
  background: #f3f4f5;

  .atitle-labels {
    label {
      margin-left: 40px;
      font-size: 18px;
      font-weight: 400;
      color: #343434;
      cursor: pointer;
    }
    .select {
      @include atitle_label_select();
      padding-bottom: 6px;
      font-weight: bold;
    }
  }
  .meal {
    width: 1200px;
    margin: 0 auto 48px;
    .contrast-title {
      color: #343434;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      line-height: 84px;
      padding-top: 16px;
    }
    .contrast {
      margin-bottom: 36px;
    }
  }
  .page-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100000;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 120px;
      height: 120px;
    }
  }
  .not-config {
    width: 100%;
    height: 360px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    p {
      font-size: 15px;
      font-weight: 400;
      color: #878787;
      line-height: 30px;
      margin-top: 12px;
    }
  }
}
</style>
